import { motion } from "framer-motion";
import Fetcher from "../hooks/Fetcher";
import {
  CalendarDays,
  Brain,
  Laptop,
  Factory,
  Wifi,
  Zap,
  Route,
  Droplets,
  Mountain,
  Building2,
  Cpu,
} from "lucide-react";

const url =
  "https://eventos.utpl.edu.ec/jsonapi/node/congresos/f2d79c7b-7b4b-4704-80af-c4a3499fd3e3" +
  "?fields[node--congresos]=title,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6," +
  "field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15,field_bloque16,field_bloque17," +
  "field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23";

function CallForPapers() {
  const DataDisplay = ({ data }) => {
    // ¡ERROR SOLUCIONADO!: Agregado el return para renderizar el JSX
    return (
      <div>
        <section className="relative overflow-hidden bg-gradient-to-br from-[#00365d] via-[#004270] to-[#005d9c] py-10">
          {/* Glow superior */}
          <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-[#febe10]/10 blur-3xl" />

          {/* Glow inferior */}
          <div className="absolute -bottom-56 -left-40 h-[28rem] w-[28rem] rounded-full bg-cyan-400/10 blur-3xl" />

          {/* Patrón de puntos */}
          <div
            className="absolute inset-0 opacity-[0.06]"
            style={{
              backgroundImage: "radial-gradient(#ffffff 1px, transparent 1px)",
              backgroundSize: "22px 22px",
            }}
          />

          <div className="relative max-w-6xl mx-auto px-6">
            <motion.div
              className="h-1 w-20 rounded-full bg-[#febe10] mb-8"
              initial={{ width: 0, opacity: 0 }}
              whileInView={{ width: 80, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            />

            <motion.div
              className="
          
                [&_h2]:text-4xl
                md:[&_h2]:text-5xl
                lg:[&_h2]:text-6xl
                [&_h2]:font-bold
                [&_h2]:leading-tight
                [&_h2]:text-white
                [&_h2]:mb-6
                [&_h2]:max-w-3xl
                [&_h2_strong]:text-[#febe10]
           
              "
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1],
              }}
              dangerouslySetInnerHTML={{
                __html: data?.texto_portada || "",
              }}
            />

            <div
              className="[&_a]:inline-flex
    [&_a]:items-center
    [&_a]:justify-center
    [&_a]:rounded-xl
    [&_a]:bg-[#febe10]
    [&_a]:px-6
    [&_a]:py-3
    [&_a]:font-semibold
    [&_a]:text-white
    [&_a]:no-underline
    [&_a]:transition-all
    hover:[&_a]:bg-[#005a9c]
    hover:[&_a]:shadow-lg"
              dangerouslySetInnerHTML={{
                __html: data?.bloque3 || "",
              }}
            />
          </div>
        </section>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-2xl border border-slate-200 bg-white p-8 shadow-lg max-w-4xl m-auto my-10"
        >
          <div
            className=" 
              [&_h2]:mb-6
              [&_h2]:text-3xl
              [&_h2]:font-bold
              [&_h2]:text-[#004270]
              [&_ul]:space-y-4
              [&_li]:relative
              [&_li]:pl-8
              [&_li]:text-lg
              [&_li]:text-slate-700
              [&_li]:before:absolute
              [&_li]:before:left-0
              [&_li]:before:top-2
              [&_li]:before:h-3
              [&_li]:before:w-3
              [&_li]:before:rounded-full
              [&_li]:before:bg-[#febe10]
              [&_strong]:font-semibold
              [&_strong]:text-[#004270]
            "
            dangerouslySetInnerHTML={{
              __html: data?.bloque1 || "",
            }}
          />
        </motion.div>
        <div
          className="
    max-w-5xl
    mx-auto
    px-10

    [&_h2]:text-3xl
    [&_h2]:font-bold
    [&_h2]:text-[#004270]
    [&_h2]:mb-6

    [&_p]:text-lg
    [&_p]:leading-8
    [&_p]:text-slate-600
    [&_p]:mb-5

    [&_ul]:list-disc
    [&_ul]:pl-6
    [&_ul]:space-y-3
    [&_ul]:mb-6

    [&_ol]:list-decimal
    [&_ol]:pl-6
    [&_ol]:space-y-3
    [&_ol]:mb-6

    [&_li]:text-slate-600
    [&_li]:leading-8

    [&_strong]:font-semibold
    [&_strong]:text-[#004270]

    [&_img]:w-[400px]
    [&_img]:m-auto
    [&_img]:rounded-2xl
    [&_img]:shadow-lg
    [&_img]:my-8

 [&_a]:text-red-600
  [&_a_strong]:text-red-600
[&_a]:border-b
[&_a]:border-red-600
[&_a]:font-medium
[&_a]:transition-colors
hover:[&_a]:text-red-500
hover:[&_a]:border-red-500
  "
          dangerouslySetInnerHTML={{
            __html: (data?.bloque2 || "").replace(
              /(<img[^>]*src=["'])(?!https?:\/\/|\/\/)([^"']+)(["'])/gi,
              "$1https://eventos.utpl.edu.ec/$2$3",
            ),
          }}
        />
        <div
          className=" mb-10  max-w-5xl
    mx-auto"
        >
          <div
            className="text-center [&_a]:inline-flex
    [&_a]:items-center
    [&_a]:justify-center
    [&_a]:rounded-xl
    [&_a]:bg-[#004270]
    [&_a]:px-6
    [&_a]:py-3
    [&_a]:font-semibold
    [&_a]:text-white
    [&_a]:no-underline
     [&_a]:text-[30px]
    [&_a]:transition-all
    hover:[&_a]:bg-[#005a9c]
    hover:[&_a]:shadow-lg"
            dangerouslySetInnerHTML={{
              __html: data?.bloque3 || "",
            }}
          />

          <div
          className="  [&_img]:w-[600px]
    [&_img]:m-auto
    [&_img]:rounded-2xl
    [&_img]:shadow-lg
    [&_img]:my-8"
           dangerouslySetInnerHTML={{
            __html: (data?.bloque4 || "").replace(
              /(<img[^>]*src=["'])(?!https?:\/\/|\/\/)([^"']+)(["'])/gi,
              "$1https://eventos.utpl.edu.ec/$2$3",
            ),
          }}
        />
        </div>
      </div>
    );
  };

  return <Fetcher url={url}>{(data) => <DataDisplay data={data} />}</Fetcher>;
}

export default CallForPapers;
